import type { FunctionComponent } from 'react'
import React from 'react'

import classnames from 'classnames'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const PowerOfAttorneyIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 50,
  height = 50,
  ...rest
}) => {
  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <path
        d="M2.5 36.2s4.5-4.5 8.9-3.6c4.5.9 7.1 1.8 10.7 1.8h6.2s4.5.9 5.4.9c.9 0 2.7 0 4.5-.9 1.8-.9 3.6-3.6 5.4-3.6 1.8 0 4.5.9 3.6 3.6s-7.1 8-7.1 8-3.6 4.5-8 4.5H10.7L2.5 36.2z"
        fill="#ffffff"
        className={styles.white}
      />
      <path
        d="m37.3 45 9.2-9.2c.6-.6.9-1.4.9-2.3 0-.9-.3-1.7-.9-2.3-1.2-1.2-3.3-1.2-4.5 0l-5.9 5.9c0 1.8-1.5 3.3-3.3 3.3h-8.4s-.1 0-.1-.1c0 0 0-.1.1-.1h8.4c1.8 0 3.2-1.4 3.2-3.2 0 0 0 0 0 0 0-1.8-1.4-3.2-3.2-3.2H19.7s0 0 0 0c-1.7-.9-3.5-1.4-6.1-1.4-4.9 0-9.2 3.5-11 5.4l7.1 8.9 6.9.1h16.2c1.7.2 3.4-.5 4.5-1.8l9.2-9.1c.6-.6 1-1.4 1-2.3 0-.9-.3-1.7-1-2.3a3.32 3.32 0 0 0-4.7 0L36 37.1c0-1.7-1.5-3.1-3.2-3.1H19.7c-1.8-.9-3.5-1.4-6.2-1.4-5 0-8.9 3.1-10.7 5v.1"
        fill="#ffffff"
        className={classnames(styles.white, styles.defaultStrokeColor)}
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2.1041"
      />
      <path
        d="M11.4 46.9c0 1-.8 1.8-1.8 1.8H4.3c-1 0-1.8-.8-1.8-1.8V32.6c0-1 .8-1.8 1.8-1.8h5.4c1 0 1.8.8 1.8 1.8"
        fill="#ffffff"
        className={classnames(styles.white, styles.defaultStrokeColor)}
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2.1041"
      />
      <path
        d="M10.7 32.2v16.5"
        fill="#ffffff"
        className={classnames(styles.white, styles.defaultStrokeColor)}
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="1.7213"
      />

      <path
        d="M16.8 26c0 1 .8 1.8 1.8 1.8h16.3c1 0 1.8-.8 1.8-1.8V8.4c0-1-.5-2.4-1.2-3.1l-3-3.2c-.7-.7-2-1.3-3-1.3H18.6c-1 0-1.8.8-1.8 1.8V26z"
        fill="#ffffff"
        className={styles.white}
      />
      <path
        d="M16.8 26c0 1 .8 1.8 1.8 1.8h16.3c1 0 1.8-.8 1.8-1.8V8.4c0-1-.5-2.4-1.2-3.1l-3-3.2c-.7-.7-2-1.3-3-1.3H18.6c-1 0-1.8.8-1.8 1.8V26z"
        fill="none"
        stroke="#000000"
        className={styles.defaultStrokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
      />
      <path
        d="M31.2.7v4.9c0 .6.5 1 1 1h4.4"
        fill="none"
        stroke="#000000"
        className={styles.defaultStrokeColor}
        strokeMiterlimit="10"
      />
      <path
        d="M20.6 9.3h12.1M20.6 15.4h12.1M20.6 18.4h12M20.6 12.3h12.1"
        fill="none"
        stroke="#000000"
        className={styles.defaultStrokeColor}
        strokeMiterlimit="10"
        strokeWidth="1.0298"
      />
      <path
        d="m20.4 24.3 1.2-1.2c.3-.3.6-.6.9-1 .1-.2.3-.3.4-.5 0-.1.1-.1.1-.2.2-.3.2-.1-.2 0h-.5c-.3 0-.1-.1-.1.1v.2c0 .2-.1.4-.1.6-.1.4-.2.8-.4 1.3-.1.4-.5 1.3-.1 1.6.3.2.8.1 1.1 0 .4-.2.7-.5 1-.6l.9-.3h.4c-.2-.1-.4-.1-.6-.2.2.7.7 1.3 1.5 1.2.3-.1.6-.2.8-.4.3-.2.4-.5.6-.8.1-.1.4-.3.5-.4.1-.1 0 0 0 0s.2 0 0 0c-.1 0 0 0 0 0h-.1c.3 0 .8-.1 1-.4.2-.3-.1-.4-.4-.4-.9.1-1.8.5-2.3 1.2-.1.1-.2.3-.3.4 0 0 0 .1-.1.1-.2.2.1.2.8-.1l-.3-.3-.3-.6c-.1-.2-.5-.2-.6-.2-.9.1-1.7.4-2.5.8-.2.1-.6.3-.7.5.1-.1.8.1.8-.1v-.2c0-.5.2-1 .4-1.4.2-.5.4-1.1.4-1.6 0-.6-.5-.6-1-.5-.5.1-.8.5-1.2.9-.3.3-.6.7-.9 1-.5.5-1 1.1-1.6 1.6-.2.2.2.4.4.4.5-.1.9-.2 1.1-.5z"
        fill="#E81C30"
        className={styles.accentColor}
      />
    </Icon>
  )
}
